/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userBusinessAlaCarteProducts

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.userBusinessAlaCarteProducts.internal.UserBusinessAlaCarteProductsUseCase
import features.userBusinessAlaCarteProducts.internal.UserBusinessAlaCarteProductsUseCase.Params
import features.userBusinessAlaCarteProducts.models.AlaCarteProductsModel


typealias UserBusinessAlaCarteProductsState = CFlow<UserBusinessAlaCarteProductsUseCaseResult?>

typealias UserBusinessAlaCarteProductsUseCaseResult = Result<AlaCarteProductsModel>

fun UserBusinessAlaCarteProductsUseCaseResult.serializeUserBusinessAlaCarteProductsApiResult(): SerializedResult<String> {
    return this.toJsonResult<AlaCarteProductsModel>()
}

/**
 * Serializes [UserBusinessAlaCarteProductsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserBusinessAlaCarteProductsState.serializeUserBusinessAlaCarteProductsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<AlaCarteProductsModel>()
    }.asCFlow()
}

/**
 * Get user A la carte list by specific business [Api] class
 */
class UserBusinessAlaCarteProductsApi : Api() {

    val userBusinessAlaCarteProductsState: UserBusinessAlaCarteProductsState
        get() = _userBusinessAlaCarteProductsState.asCFlow()

    companion object {
        private val _userBusinessAlaCarteProductsState: MutableStateFlow<UserBusinessAlaCarteProductsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userBusinessAlaCarteProductsUseCase = UserBusinessAlaCarteProductsUseCase()

    /**
     * Get user A la carte list by specific business
     */
    suspend fun getUserBusinessAlaCarteProducts(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): Result<AlaCarteProductsModel> {
        /* set state to Loading as soon as function is called */
        _userBusinessAlaCarteProductsState.value = Loading()
        val result = this.userBusinessAlaCarteProductsUseCase(
            Params(
                overrideHeaders = overrideHeaders,
                businessId = businessId
            )
        ) { result ->
            _userBusinessAlaCarteProductsState.value = result
            return@userBusinessAlaCarteProductsUseCase result
        }
        return result
    }

}
